import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import { ShieldCheck } from 'lucide-react';

import { isBE } from '@/react/portainer/feature-flags/feature-flags.service';
import { useWhiteLabel } from '@/react/portainer/feature-flags/useWhiteLabel';
import { usePublicSettings } from '@/react/portainer/settings/queries';

import { Icon } from '@@/Icon';

import { UpdateBannerWrapper } from '../UpdateBanner';

import { UpdateNotification } from './UpdateNotifications';
import { BuildInfoModalButton } from './BuildInfoModal';
import '@reach/dialog/styles.css';
import styles from './Footer.module.css';

export function Footer() {
  return isBE ? <BEFooter /> : <CEFooter />;
}

function CEFooter() {
  return (
    <div className={clsx(styles.root, 'text-center')}>
      <UpdateNotification />

      <FooterContent>
        <span>&copy;</span>
        <span>Portainer Community Edition</span>

        <BuildInfoModalButton />
      </FooterContent>
    </div>
  );
}

function BEFooter() {
  const { data: whitelabel } = useWhiteLabel();

  const { data: publicSettings } = usePublicSettings();
  const isFIPSMode = !!publicSettings?.FIPSMode;

  return (
    <div className={clsx(styles.root, 'text-center')}>
      <UpdateBannerWrapper />

      {isFIPSMode && (
        <FooterContent>
          <Icon icon={ShieldCheck} mode="alt" />
          <span>FIPS mode enabled</span>
        </FooterContent>
      )}

      {!whitelabel && (
        <FooterContent>
          <span>&copy;</span>
          <span>Portainer Business Edition</span>
          <BuildInfoModalButton />
        </FooterContent>
      )}
    </div>
  );
}

function FooterContent({ children }: PropsWithChildren<unknown>) {
  return (
    <div className="mx-auto flex items-baseline justify-center space-x-1 text-2xs text-gray-5 be:text-gray-6">
      {children}
    </div>
  );
}
